<script lang="ts">
    import type { Availability } from '@shared/types/types';

    interface Props {
        availability: Availability | undefined;
    }

    let { availability }: Props = $props();
</script>

{#if availability?.detail}
    <span class="oc-copy-75" data-testid="AvailabilityText">
        {availability.detail}
    </span>
{/if}
